import { SDKOptions } from "~/types/options";

export type Options = {
  lat?: number;
  lng?: number;
  geographyId?: string;
  image?: string;
};

export type NeighborhoodHeroProps = SDKOptions<
  Options,
  {
    options: Options | undefined;
  }
>;

export enum TrackingPipelineEvents {
  SDK_VIEWED = "neighborhood-hero-Viewed",
}

// Why are these named differently?
// https://docs.mixpanel.com/docs/data-structure/events-and-properties#name-events-and-properties-consistently
export enum AnalyticsEvents {
  SDK_VIEWED = "sdk_viewed",
}
